const GatewaysImageMap = {
    A1Gateway: '/static/gateways/A1Gateway.png',
    AmexVPC: '/static/gateways/AmexVPC.png',
    ApcoPay: '/static/gateways/ApcoPay.png',
    AstroPay: '/static/gateways/AstroPay.png',
    AstroPayCard: '/static/gateways/AstroPayCard.png',
    AuthorizeNet: '/static/gateways/AuthorizeNet.png',
    Bambora: '/static/gateways/Beanstream.png',
    BitPay: '/static/gateways/BitPay.png',
    BlueSnap: '/static/gateways/BlueSnap.png',
    BraintreePayments: '/static/gateways/BraintreePayments.png',
    Cardknox: '/static/gateways/Cardknox.png',
    Cashflows: '/static/gateways/Cashflows.png',
    CASHlib: '/static/gateways/CASHlib.png',
    CashToCode: '/static/gateways/CashToCode.png',
    CauriPayment: '/static/gateways/CauriPayment.png',
    Cayan: '/static/gateways/Cayan.png',
    Chase: '/static/gateways/Chase.png',
    Credorax: '/static/gateways/Credorax.png',
    Cryptonator: '/static/gateways/Cryptonator.png',
    DataCash: '/static/gateways/DataCash.png',
    Dengi: '/static/gateways/Dengi.png',
    ecoPayz: '/static/gateways/ecoPayz.png',
    EcorePay: '/static/gateways/EcorePay.png',
    Elavon: '/static/gateways/Elavon.png',
    eMerchantPay: '/static/gateways/eMerchantPay.png',
    FinTecSystems: '/static/gateways/FinTecSystems.png',
    Flexepin: '/static/gateways/Flexepin.png',
    Forte: '/static/gateways/Forte.png',
    FundSend: '/static/gateways/FundSend.png',
    GET: '/static/gateways/GET.png',
    Gigadat: '/static/gateways/Gigadat.png',
    GlobalOnePay: '/static/gateways/GlobalOnePay.png',
    Gpaysafe: '/static/gateways/Gpaysafe.png',
    Greenbox: '/static/gateways/Greenbox.png',
    iCheque: '/static/gateways/iCheque.png',
    iDebit: '/static/gateways/iDebit.png',
    Ilixium: '/static/gateways/Ilixium.png',
    Ingenico: '/static/gateways/Ingenico.png',
    INOVAPAY: '/static/gateways/INOVAPAY.png',
    Inovio: '/static/gateways/Inovio.png',
    Intuit: '/static/gateways/Intuit.png',
    InstaDebit: '/static/gateways/InstaDebit.png',
    IpayOptions: '/static/gateways/IpayOptions.png',
    Jeton: '/static/gateways/Jeton.png',
    JetPay: '/static/gateways/JetPay.png',
    Moneris: '/static/gateways/Moneris.png',
    MtaPay: '/static/gateways/MtaPay.png',
    Neteller: '/static/gateways/Neteller.png',
    NinjaWallet: '/static/gateways/NinjaWallet.png',
    NMI: '/static/gateways/NMI.png',
    OchaPay: '/static/gateways/OchaPay.png',
    Onlineueberweisen: '/static/gateways/Onlineueberweisen.png',
    Optimal: '/static/gateways/Paysafe.png',
    Panamerican: '/static/gateways/Panamerican.png',
    PandaGateway: '/static/gateways/PandaGateway.png',
    ParamountEft: '/static/gateways/InstaDebit.png',
    Pay4Fun: '/static/gateways/Pay4Fun.png',
    Payeezy: '/static/gateways/Payeezy.png',
    Payflow: '/static/gateways/Payflow.png',
    PayPal: '/static/gateways/PayPal.png',
    Payr: '/static/gateways/Payr.png',
    Paysafe: '/static/gateways/Paysafe.png',
    Payvision: '/static/gateways/Payvision.png',
    Plugnpay: '/static/gateways/Plugnpay.png',
    Realex: '/static/gateways/Realex.png',
    Realtime: '/static/gateways/RealTime.png',
    RebillyProcessor: '/static/gateways/RebillyProcessor.png',
    Redsys: '/static/gateways/Redsys.png',
    Rotessa: '/static/gateways/Rotessa.png',
    RPN: '/static/gateways/RPN.png',
    Sagepay: '/static/gateways/Sagepay.png',
    SeamlessChex: '/static/gateways/SeamlessChex.png',
    Skrill: '/static/gateways/Skrill.png',
    SmartInvoice: '/static/gateways/SmartInvoice.png',
    SMSVoucher: '/static/gateways/SMSVoucher.png',
    SparkPay: '/static/gateways/SparkPay.png',
    StaticGateway: '/static/gateways/StaticGateway.png',
    Stripe: '/static/gateways/Stripe.png',
    UPayCard: '/static/gateways/UPayCard.png',
    USAePay: '/static/gateways/USAePay.png',
    VantivLitle: '/static/gateways/VantivLitle.png',
    vegaaH: '/static/gateways/vegaaH.png',
    Walpay: '/static/gateways/Walpay.png',
    Wirecard: '/static/gateways/Wirecard.png',
    Worldpay: '/static/gateways/Worldpay.png',
};

export default GatewaysImageMap;
